import { gql } from "apollo-boost"
export const SET_EMAIL_PROJECT_MONTH_STATUS_QUERY = gql`
    mutation SetMonitoringEmail ($email: String!, $typeMonitoring: String!, $month:String!, $proyect:String!) {
      SetMonitoringEmail(email: $email, typeMonitoring: $typeMonitoring, month:$month, proyect:$proyect )
    }
`
